// ForgotPasswordPage SaaS — chỉ wire @cnv/ui/pages/auth/ForgotPasswordPage với branding.
// Logic + form sống ở @cnv/ui per HOST_CONTRACT.md (1 cty = 1 component lib).
// Host's useAuth() cung cấp forgotPassword(email) → POST /api/v1/auth/password/forgot.

import ForgotPasswordPage from '@cnv/ui/pages/auth/ForgotPasswordPage';
import '../i18n-host';

export default function ForgotPasswordPageSaas() {
  return (
    <ForgotPasswordPage
      logoSrc="/cnvwork.png"
      logoAlt="CNV Work"
      brandName="CNV Work"
      tagline="CRM · OPERATIONS · AI AGENT"
      variant="pink"
      loginHref="/login"
    />
  );
}
